exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1mTEY{position:fixed;margin:0;padding:0;top:150px;left:0;list-style:none;z-index:5}", ""]);

// exports
exports.locals = {
	"navigationIz": "_1mTEY"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/LeftNavigation/LeftNavigation.css
// module id = 1033
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13